module.exports = __webpack_public_path__ + "assets/icon_home_highlight.f3ba3497.svg";